import React from "react";
import { ArrowUpRight, ChevronRight } from "lucide-react";

export interface CountCardProps {
  title: string;
  count: number | string;
  currency?: string;
  icon?: any;
  subtitle?: string;
  badgeText?: string;
  badgeType?: "trend-up" | "badge-gray" | "badge-blue" | "link-review";
  iconBgClass?: string;
  iconColorClass?: string;
}

const CountCard: React.FC<CountCardProps> = ({
  title,
  count,
  currency,
  icon,
  subtitle,
  badgeText,
  badgeType = "trend-up",
  iconBgClass = "bg-emerald-50 text-emerald-600 border-emerald-100/70",
}) => {
  return (
    <div className="bg-white rounded-2xl border border-slate-200/80 p-3 shadow-2xs hover:shadow-sm transition-all duration-200 flex flex-col justify-between h-full group hover:border-slate-300">
      {/* Top Row: Icon + Badge */}
      <div className="flex items-center justify-between mb-3">
        <div
          className={`w-9 h-9 rounded-xl flex items-center justify-center shrink-0 border ${iconBgClass}`}
        >
          {typeof icon === "string" ? <i className={icon}></i> : icon}
        </div>

        {/* Top-Right Badge */}
        {badgeText && (
          <span
            className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold border ${
              badgeType === "badge-gray"
                ? "bg-slate-50 text-slate-600 border-slate-200/80"
                : badgeType === "badge-blue"
                ? "bg-blue-50 text-blue-700 border-blue-200/60"
                : "bg-emerald-50 text-emerald-700 border-emerald-100/80"
            }`}
          >
            <span>{badgeText}</span>
          </span>
        )}
      </div>

      {/* Middle: Title & Big Number */}
      <div>
        <div className="text-[11px] font-bold text-slate-600 uppercase tracking-wider">
          {title}
        </div>
        <div className="text-2xl font-extrabold text-slate-900 tracking-tight mt-1 leading-none">
          {typeof count === "number" ? count.toLocaleString() : count ?? 0}
          {currency ? ` ${currency}` : ""}
        </div>
      </div>

      {/* Bottom: Subtitle */}
      {subtitle && (
        <div className="text-[11px] text-slate-400 font-medium mt-2.5 truncate">
          {subtitle}
        </div>
      )}
    </div>
  );
};

export default CountCard;
